/**
 * Lấy danh sách permissions của user hiện tại.
 * Đọc từ user.permissions (flat array được gắn vào user object khi login/refresh).
 * Fallback: derive từ user.roles[x].permissions nếu user cũ chưa re-login.
 */
export function getPermissions() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user?.roles?.some(r => r.name === 'admin')) return ['*'];
        if (Array.isArray(user?.permissions) && user.permissions.length > 0) return user.permissions;
        // Fallback cho session cũ chưa có user.permissions
        if (user?.roles) {
            return [...new Set(
                user.roles.flatMap(r => (r.permissions || []).map(p => p.name))
            )];
        }
        return [];
    } catch {
        return [];
    }
}

/**
 * Kiểm tra user có permission cụ thể không.
 * Admin (['*']) luôn trả về true.
 */
export function hasPermission(permission) {
    const perms = getPermissions();
    return perms.includes('*') || perms.includes(permission);
}

/**
 * Lấy role đầu tiên của user hiện tại.
 */
export function getUserRole() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user?.roles?.[0]?.name || null;
    } catch {
        return null;
    }
}

/**
 * Kiểm tra user có quyền truy cập admin panel không (admin hoặc staff).
 */
export function hasAdminAccess() {
    const role = getUserRole();
    return role === 'admin' || role === 'staff';
}
